const React = require('react')
const ReactDOM = require('react-dom/client')
const ExperienceListing = require('./components/ExperienceListing.jsx').default

function mountExperienceListing() {
  const rootEl = document.getElementById('experience-listing-root')
  if (rootEl && !rootEl.dataset.reactRoot) {
    rootEl.dataset.reactRoot = 'mounted'
    const root = ReactDOM.createRoot(rootEl)
    root.render(React.createElement(ExperienceListing))
  }
}

module.exports = { mountExperienceListing }
